<template>
  <div>
    <span
      class="icon iconfont icon-tag status-tag"
      :class="getStatus(status).icon"
      :style="{ color: getStatus(status).color }"
      v-if="getStatus(status).icon"
    />
    <span
      :style="{
        color: getStatus(status).color,
        borderColor: getStatus(status).color
      }"
      class="text-tag status-tag"
      v-if="getStatus(status).text"
    >
      {{ getStatus(status).text }}
    </span>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { ApproveStatus, StatusOptions } from '@/enums/flow'

defineProps({
  status: {
    type: String as PropType<ApproveStatus>,
    default: ''
  }
})

function getStatus(status: ApproveStatus) {
  return StatusOptions[status] || {}
}
</script>
<style lang="scss" scoped>
.status-tag {
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  box-sizing: border-box;
}
.icon-tag {
  font-size: 18px;
}

.text-tag {
  border-width: 1px;
  border-style: solid;
  border-radius: 16px;
}
</style>
